import $ from 'jquery'
import memoize from 'lodash/memoize'

import PoziAPIData from 'api/data'
import * as Model from 'api/model'

/**
 * Pozi Scripts module.
 * This is used to delay load script libraries.
 */
const PoziPingdom = memoize(function () {
  // ============================================================
  // Public Variables
  // ============================================================

  /**
   * This object
   * @type {object}
   */
  const _ = this

  // ============================================================
  // Private Variables
  // ============================================================
  const CONSTANTS = {
    checks: {
      include: {
        'Data.gov.au Web Map Service': true,
        'DELWP DataVic Web Map Service': true,
        'DELWP Image Web Server': true,
        'Pozi App': true,
        'Vicmap API Map Tile Service': true
      }
    }
  }

  // ============================================================
  // Public Functions
  // ============================================================
  _.run = function () {
    const timestamp = Date.now()
    const url = 'https://proxy.pozi.com/https://api.pingdom.com/api/3.1/checks?_=' + timestamp

    PoziAPIData().ajax({
      url,
      method: 'GET',
      headers: {
        authkey: 'pingdom'
      },
      success: function (data) {
        if (data.checks) {
          for (const key in data.checks) {
            if (!Object.hasOwnProperty.call(data.checks, key)) continue
            if (CONSTANTS.checks.include[data.checks[key].name] && data.checks[key].status === 'down') {
              displayNotification(data.checks[key].name)
              break
            }
          }
        }
      },
      error: function (data) {
        console.log('Failed to get pingdom data.')
      }
    })
  }

  // ============================================================
  // Private Functions
  // ============================================================
  const displayNotification = function (name) {
    const bShowWarningBannerForPingdom = Model.get('config.layout.showWarningBanner.pingdom', true)

    if (!bShowWarningBannerForPingdom) {
      console.log('Flag set to skip showing the pingdom warning message.')
      return
    }

    $('#message_box').append(
      $('<div>')
        .attr('class', 'alert alert-warning alert-dismissible')
        .attr('role', 'alert')
        .append(
          $('<button>')
            .attr('type', 'button')
            .attr('class', 'close')
            .attr('data-dismiss', 'alert')
            .append(
              $('<span>')
                .attr('aria-hidden', 'true')
                .html('&times;')
            )
            .append(
              $('<span>')
                .attr('class', 'sr-only')
                .html('Close')
            )
        )
        .append(
          "<img alt='hazard' id='hazardicon'src='./img/custom/hazard.svg'>Service may be limited due to <b>" +
            name +
            "</b> outage. Check <a target='_blank' href='http://stats.pingdom.com/w3ggvgl5rino'>status</a>."
        )
    )
  }
})

export default PoziPingdom
